import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { ActionTypes, IVersaoApp } from "./types";

export const reducers = createReducer(
  {
    api: "",
    model: "",
    service: "",
    app: "",
  },
  {
    [ActionTypes.SET]: (state, action: PayloadAction<IVersaoApp>) =>
      action.payload,
  }
);
